import type { RewardedAdProvider, ShowRewardedOptions } from "./adPorts.js";

export class NoopRewardedAdProvider implements RewardedAdProvider {
  showRewarded(opts: ShowRewardedOptions): void {
    opts.onSkip?.();
  }
}
